import { render, staticRenderFns } from "./IntegrationImageButton.vue?vue&type=template&id=ce1bbac2&scoped=true&lang=pug&"
import script from "./IntegrationImageButton.vue?vue&type=script&lang=js&"
export * from "./IntegrationImageButton.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationImageButton.vue?vue&type=style&index=0&id=ce1bbac2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1bbac2",
  null
  
)

export default component.exports